<template>
  <div class="row no-gutters">

    <div id="col-left-with-text" class="col-sm-12 col-md-12 col-lg-4 changePassword">

      <div class="w-100">

        <div>
          <img class="logo-img" :src="require(`@/assets/images/b122/logo.png`)" alt="Logo Login">
        </div>

        <div id="login-div">

          <b-alert :show="showError" variant="danger" class="mt-4">{{ textError }}</b-alert>

          <b-alert :show="showSuccess" variant="success" class="mt-4">{{$t('new.password.registered')}}</b-alert>

          <div v-if="!showError && !showSuccess">
            <h1 class="mt-4">
              {{ $t('choose.your.new.password') }}
            </h1>

            <form ref="form" @submit.stop.prevent="handleSubmit" class="mt-4">

              <!-- New password -->
              <b-form-group
                :label="$t('new.password')"
                label-for="newPassword-input"
                :invalid-feedback="newPassword.invalidFeedback"
                :state="newPassword.state"
              >
                <b-form-input
                  class="input-login"
                  id="newPassword-input"
                  v-model="newPassword.value"
                  :state="newPassword.state"
                  type="password"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- New password repeat -->
              <b-form-group
                :label="$t('confirm.new.password')"
                label-for="newPasswordRepeat-input"
                :invalid-feedback="newPasswordRepeat.invalidFeedback"
                :state="newPasswordRepeat.state"
              >
                <b-form-input
                  class="input-login"
                  id="newPasswordRepeat-input"
                  v-model="newPasswordRepeat.value"
                  :state="newPasswordRepeat.state"
                  type="password"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>

              <div class="mt-4">
                <b-button type="submit" class="btn-block" variant="primary">{{ $t('Validate') }}</b-button>
              </div>

            </form>
          </div>

        </div>

      </div>
    </div>

    <div id="col-right-with-image" class="col-sm-12 col-md-12 col-lg-8 d-lg-block d-xl-block" :style="{'background-image': 'url(' + require(`@/assets/images/b122/login-background.png`) + ')'}">
    </div>

  </div>

</template>

<script>

import api from '../../services/api'

export default {

  name: "ChangePassword",

  data() {
    return {

      token: this.$route.params.token,
      language: this.$route.params.language,

      showSuccess: false,
      showError: false,
      textError: "",

      newPassword: {
        value: null,
        state: null,
        invalidFeedback: null
      },

      newPasswordRepeat: {
        value: null,
        state: null,
        invalidFeedback: null
      }
    }
  },

  mounted() {
    this.checkToken()
  },

  methods: {

    checkToken() {

      let data = new FormData()
      data.append('token', this.token)
      data.append('language', this.language)

      api({
        method: 'POST',
        url: `/forgotPassword/checkUpdatePasswordToken`,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 418) {
            this.textError = error.response.data.message
            this.showError = true
          }
        });
    },

    handleSubmit() {

      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('token', this.token)
      formData.append('newPassword', this.newPassword.value.trim())
      formData.append('newPasswordRepeat', this.newPasswordRepeat.value.trim())
      formData.append('language', this.language)

      api({
        method: 'POST',
        url: `/forgotPassword/updatePasswordFromEmail`,
        data: formData
      })
        .then((response) => {
          this.showSuccess = true
          this.showError = false
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.textError = error.response.data.message
            this.showError = true
          } else {
            this.textError = "Erreur serveur."
            this.showError = true
          }
        });
    },


    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
      }
      this.newPassword.state = this.newPassword.value != null && this.newPassword.value.trim() !== ""
      this.newPassword.invalidFeedback = 'Ce champ est requis'
      this.newPasswordRepeat.state = this.newPasswordRepeat.value != null && this.newPasswordRepeat.value.trim() !== ""
      this.newPasswordRepeat.invalidFeedback = 'Ce champ est requis'
      if (this.newPassword.state && this.newPassword.value.length < 7) {
        this.newPassword.state = false
        this.newPassword.invalidFeedback = "Votre mot de passe doit contenir au moins 7 caractères"
        this.newPasswordRepeat.state = false
        this.newPasswordRepeat.invalidFeedback = ''
        valid = false
      }
      if (this.newPassword.state && this.newPasswordRepeat.state && this.newPassword.value !== this.newPasswordRepeat.value) {
        this.newPasswordRepeat.state = false
        this.newPasswordRepeat.invalidFeedback = 'Le nouveau mot de passe ne correspond pas'
        valid = false
      }
      return valid
    },

  }

};
</script>

<style scoped>

#col-right-with-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: top;
  background-position-x: center;
  height: 100vh;
}

#col-left-with-text {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 5%;
  padding-left: 5%;
  height: 100vh;
}

@media (max-width: 992px) {
  #col-right-with-image {
    display: none;
  }
  #col-left-with-text {
    display: block;
  }
  .w-100 {
    min-height: 100vh;
    margin-top: min(150px, 50%);
  }
  .logo-img {
    max-width: 400px;
  }
  #login-div{
    margin-top: 200px;
  }

}

@media (max-height: 700px) {
  .w-100 {
    margin-top: min(150px,50%);
  }

  #col-right-with-image {
    height: 100vh;
  }

}

.logo-img {
  max-height: 140px;
  position: absolute;
  left: 0;
  top: 10%;
  width: 80%;
}

h1 {
  font-size: var(--title-level-one-font-size);
}

h2 {
  font-size: var(--title-level-two-font-size);
}

.forgot-password-link {
  color: var(--secondary-text-color);
}

.input-login {
  background-color: #81c8b6 !important;
}

.changePassword {
  background-color: var(--secondary-color);
}
</style>



// WEBPACK FOOTER //
// src/views/auth/ChangePassword.vue